export const TEST_MODE_LOCAL_STORAGE_KEY = 'TEST_MODE';
